import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Offices,
  CostCenter,
  GetAccounts,
  GetBillsToPay,
  CreateBillsToPay,
  UpdateBillsToPay,
  DeleteBillsToPay,
  GetBillsToPayByHash,
  GetCategoryFinanceOrganized,
  GetSuppliesLookup,
  Organizations,
} from '../../../store/actions';

/**
 * BillsToReceiveInjection is responsible for injecting the methods about store.
 *
 * @return
 *  get: () => Void
 *
 */
export const BillsToReceiveInjection = () => {
  /* constants */
  const dispatch = useDispatch();

  /**
   * @connectors
   *
   * these methods are responsible for accessing the store and dispatch the actions.
   * these guarantee that the module will be connected independent of methods used.
   * but you should always follow the rules of the methods.
   */

  /**
   * @return Void
   */
  const getCostCenter = async () => {
    dispatch(CostCenter());
  };

  const getAccounts = async () => {
    dispatch(GetAccounts());
  };

  const getOrganizations = async () => {
    dispatch(Organizations());
  };

  const getOffices = async () => {
    dispatch(Offices());
  };

  const getFinancialCategoriesOrganized = async (type) => {
    dispatch(GetCategoryFinanceOrganized(type));
  };

  const getSuppliersLookup = async () => {
    dispatch(GetSuppliesLookup());
  };

  /**
   * @return Void  
  /**
   * 
   *
   *
   */

  const getBillsToPay = (period, status, type) => {
    dispatch(GetBillsToPay(period, status, type));
  };

  const getBillsToPayByHash = useCallback(
    (hash) => {
      dispatch(GetBillsToPayByHash(hash));
    },
    [dispatch]
  );

  const createBillsToPay = (data) => {
    dispatch(CreateBillsToPay(data));
  };

  const updateBillsToPay = (hash, data) => {
    dispatch(UpdateBillsToPay(hash, data));
  };

  const deleteBillsToPay = (hash) => {
    dispatch(DeleteBillsToPay(hash));
  };

  const {
    bills,
    summary,
    offices,
    loading,
    success,
    accounts,
    costCenters,
    billsByHashId,
    organizations,
    suppliersLookup,
    categoryFinanceOrganized,
  } = useSelector((state) => ({
    bills: state.BillsToPay.bills,
    summary: state.BillsToPay.summary,
    loading: state.BillsToPay.loading,
    offices: state.Offices.offices,
    success: state.BillsToPay.success,
    accounts: state.Accounts.accounts,
    costCenters: state.CostCenter.costCenters,
    billsByHashId: state.BillsToPay.billsByHash,
    suppliersLookup: state.SuppliesList.suppliersLookup,
    categoryFinanceOrganized: state.CategoryFinance.categoryFinanceOrganized,
    organizations: state.Organizations.organizations,
  }));

  return {
    bills,
    summary,
    loading,
    offices,
    success,
    accounts,
    costCenters,
    organizations,
    suppliersLookup,
    categoryFinanceOrganized,
    billsByHashId,
    getOffices,
    getCostCenter,
    getAccounts,
    getBillsToPay,
    getBillsToPayByHash,
    getOrganizations,
    createBillsToPay,
    updateBillsToPay,
    deleteBillsToPay,
    getSuppliersLookup,
    getFinancialCategoriesOrganized,
  };
};
